export default __webpack_public_path__ + "static/media/a.b07abe39.svg";